<template>
  <div class="download-cart btnIcon">
    <div id="downloadCart">
      <lk-badge :count="count" type="primary" :offset="[2, -8]">
        <a href="javascript:;" @click="showDownload">
          <span class="iconfont mr8">&#xe63e;</span>
          <span class="" style="position: relative; top: -2px;">下载管理</span>
        </a>
      </lk-badge>
    </div>
    <div class="cart-container">
      <div v-for="(cart, index) in carts" :key="index">
        <transition name="drop" @before-enter="beforeDrop" @enter="dropping" @after-enter="afterDrop">
          <div class="cart" v-show="cart.show">
            <div class="inner inner-hook iconfont">&#xe63f;</div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadCart',
  data() {
    return {
      carts: [
        {
          show: false,
        },
        {
          show: false,
        },
        {
          show: false,
        },
        {
          show: false,
        },
        {
          show: false,
        },
      ],
      dropBalls: [],
    };
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {},
  methods: {
    showDownload() {
      this.$router.push({
        name: 'download',
      });
    },
    drop(el) {
      for (let i = 0; i < this.carts.length; i++) {
        const cart = this.carts[i];
        if (!cart.show) {
          cart.show = true;
          cart.el = el;
          this.dropBalls.push(cart);
          return;
        }
      }
    },
    beforeDrop(el) { // 开始的动画
      let count = this.carts.length;
      while (count--) {
        const cart = this.carts[count];
        if (cart.show && cart.el) {
          const rect = cart.el.getBoundingClientRect();
          // const x = rect.left + 32;
          const x = rect.left;
          // const y = -(window.innerHeight - rect.top - 22);
          const y = -(window.innerHeight - rect.top - 16);
          el.style.display = '';
          el.style.webkitTransform = `translate3d(0,${y}px,0)`;
          el.style.transform = `translate3d(0,${y}px,0)`;
          const inner = el.getElementsByClassName('inner-hook')[0];
          inner.style.webkitTransform = `translate3d(${x}px,0,0)`;
          inner.style.transform = `translate3d(${x}px,0,0)`;
        }
      }
    },
    dropping(el, done) {
      el.offsetHeight; // 触发重绘
      el.offsetWidth;

      this.$nextTick(() => {
        if (el && document.getElementById('downloadCart')) {
          const ballPostion = el.getBoundingClientRect();
          const downloadCartPostion = document.getElementById('downloadCart').getBoundingClientRect();
          // const distX = downloadCartPostion.left - ballPostion.left + 32;
          const distX = downloadCartPostion.left - ballPostion.left;
          const distY = downloadCartPostion.top - ballPostion.top - 6;
          const inner = el.getElementsByClassName('inner-hook')[0];
          inner.style.transform = `translate(${distX}px,${distY}px)`;
          inner.style.transition = 'all 0.5s cubic-bezier(.4,-0.3,1,.68)';
          el.addEventListener('transitionend', done);
        }
      });
    },
    afterDrop(el) { // 动画完成
      const cart = this.dropBalls.shift();
      if (cart) {
        cart.show = false;
        el.style.display = 'none';
      }
    },
  },
  components: {},
};
</script>

<style scoped>
  .download-cart {}

  .cart-container {}

  .cart-container .cart {
    position: fixed;
    left: 32px;
    bottom: 22px;
    z-index: 200;
    transition: all 87s cubic-bezier(.63, -0.32, .82, .56);
  }

  .cart-container .cart .inner {
    width: 16px;
    height: 16px;
    font-size: 20px;
    font-weight: bold;
    color:  #2D8CF0;
    transition: all 0.56s linear;
  }

</style>
